import React, { useState } from 'react';
import { toast } from 'sonner';
import { FilePlus2, Loader2 } from 'lucide-react';

// P2 · Turns this Re-Roof spec / Repairs option into its own sibling draft quote (same parent, linked variant group).
export function MakeSeparateQuoteButton({ api, appraisalId, body, label, testid }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!window.confirm(`Make "${label}" a separate quote? A new draft is created under the same parent, linked to this one as an option. When the client accepts one, the others are marked Superseded.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/appraisals/${appraisalId}/variant-quote`, body);
      toast.success(`Draft created: ${data.draft.variant_label} — switching to it`);
      window.dispatchEvent(new CustomEvent('rtr:variant-quote-created', { detail: { id: data.draft.id } }));
    } catch (e) { toast.error(e?.response?.data?.detail || 'Could not create the variant quote'); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={go} disabled={busy} data-testid={testid}
      className="inline-flex items-center gap-1 px-2.5 py-1 text-xs bg-sky-600 hover:bg-sky-700 text-white rounded font-semibold disabled:opacity-50">
      {busy ? <Loader2 size={11} className="animate-spin" /> : <FilePlus2 size={11} />} Make separate quote
    </button>
  );
}
